import * as React from 'react';
import DataColumn from '../../components/controls/datagrid/DataColumn';
import DataList from '../../components/controls/datagrid/DataList';

type Props = {
    items: any,
    controller: string,
    modal?: React.ReactNode,
    modaltitle?: string,
    modalwidth?: string,
    state?: any,
    readOnly?: boolean
}

export default (props: Props) => {
    return (
        <>
            <DataList
                items={props.items}
                modaltitle={props.modaltitle}
                modalwidth={props.modalwidth}
                modalController={props.controller}
                modal={props.modal}
                state={props.state}
                readOnly={props.readOnly}
            >
                <DataColumn kid='column4' name='Codice' fieldName='code' maxWidth={250} align='left' />
                <DataColumn kid='column4' name='Denominazione' fieldName='denomination' minWidth={200} align='left' />
            </DataList>
        </>
    );
}
